import { Card } from "react-bootstrap";
import BrowseJobsPagination from "./BrowseJobsPagination";

const BrowseRecentJobs = ({
  jobs,
  companyLogos,
  page,
  size,
  totalPages,
  handlePageSizeChange,
  handlePageClick,
  calculateDaysAgo,
}) => {
  return (
    <>
      <div className="d-flex flex-wrap justify-content-center">
        {jobs.map((job) => {
          const daysAgoText = calculateDaysAgo(job.postingDate);
          return (
            <Card
              style={{
                width: "100%",
                maxWidth: "250px",
                margin: "10px",
                paddingTop: "0px",
                boxSizing: "border-box",
              }}
              key={job.id}
            >
              <Card.Body>
                <img
                  src={
                    companyLogos[job.companyName] ||
                    "https://static.vecteezy.com/system/resources/previews/013/899/376/original/cityscape-design-corporation-of-buildings-logo-for-real-estate-business-company-vector.jpg"
                  }
                  alt={`${job.companyName} logo`}
                  style={{
                    width: "30%",
                    height: "30%",
                    position: "absolute",
                    top: "5px",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const companyUrl = `/companyPage/companyName/${encodeURIComponent(
                      job.companyName,
                    )}`;
                    window.open(companyUrl, "_blank", "noopener,noreferrer");
                  }}
                />

                <Card.Subtitle
                  className="mb-2 text-muted"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const companyUrl = `/companyPage/companyName/${encodeURIComponent(
                      job.companyName,
                    )}`;
                    window.open(companyUrl, "_blank", "noopener,noreferrer");
                  }}
                >
                  {job.companyName}
                </Card.Subtitle>

                <Card.Title
                  style={{
                    marginTop: "40px",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const slug = `${job.jobId}-${(job.jobTitle || "")
                      .replace(/\s+/g, "-")
                      .toLowerCase()}-${(job.companyName || "")
                      .replace(/\s+/g, "-")
                      .toLowerCase()}`;

                    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;

                    window.open(shareUrl, "_blank", "noopener,noreferrer");
                  }}
                >
                  {job.jobTitle}
                </Card.Title>

                <Card.Text
                  style={{
                    fontSize: daysAgoText === "> 7 days ago" ? "10px" : "14px",
                  }}
                >
                  {daysAgoText}
                </Card.Text>
              </Card.Body>
            </Card>
          );
        })}
      </div>
      <BrowseJobsPagination
        page={page}
        pageSize={size}
        totalPages={totalPages}
        handlePageSizeChange={handlePageSizeChange}
        handlePageClick={handlePageClick}
      />
    </>
  );
};

export default BrowseRecentJobs;
